import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-loading-skeleton/dist/skeleton.css';

import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ptBR as ptBRLocaleText } from '@mui/x-date-pickers/locales';
import { AuthProvider } from 'contexts/auth';
import { CartProvider } from 'contexts/cart';
import { LoadingProvider } from 'contexts/loading';
import { ptBR } from 'date-fns/locale';
import Routes from 'routes';
import { theme } from 'theme';
import { getSlugFromURL, getTitle } from 'utils/whiteLabel';

function App() {
  const PROJECT = getSlugFromURL();

  useEffect(() => {
    let iconLink = document.querySelector("link[rel~='icon']");
    if (!iconLink) {
      iconLink = document.createElement('link');
      iconLink.setAttribute('rel', 'icon');
      document.getElementsByTagName('head')[0].appendChild(iconLink);
    }
    iconLink.setAttribute('href', `${process.env.PUBLIC_URL}/${PROJECT}/logo_mini.png`);

    let iconAppleLink = document.querySelector("link[rel~='apple-touch-icon']");
    if (!iconAppleLink) {
      iconAppleLink = document.createElement('link');
      iconAppleLink.setAttribute('rel', 'apple-touch-icon');
      document.getElementsByTagName('head')[0].appendChild(iconAppleLink);
    }
    iconAppleLink.setAttribute('href', `${process.env.PUBLIC_URL}/${PROJECT}/logo192.png`);

    let manifestLink = document.querySelector("link[rel~='manifest']");
    if (!manifestLink) {
      manifestLink = document.createElement('link');
      manifestLink.setAttribute('rel', 'manifest');
      document.getElementsByTagName('head')[0].appendChild(manifestLink);
    }
    manifestLink.setAttribute('href', `${process.env.PUBLIC_URL}/${PROJECT}/manifest.json`);

    let titleTag = document.querySelector('title');
    if (!titleTag) {
      titleTag = document.createElement('title');
      document.getElementsByTagName('head')[0].appendChild(titleTag);
    }
    titleTag.innerHTML = `${getTitle(PROJECT)}`;
    // <title>%REACT_APP_WEBSITE_NAME%</title>
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={ptBR}
        localeText={ptBRLocaleText.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <AuthProvider>
          <LoadingProvider>
            <CartProvider>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              <Routes />
            </CartProvider>
          </LoadingProvider>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
